import React, { useEffect, useState } from "react";
import axios from "axios";

import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";

import EditServiceForm from "../service-modal.jsx";
import useServiceGroup from "../../../hooks/services/useServiceGroup";
import AlertMessage from "../../../components/AlertMessage";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal";
import Breadcrumb from "../../../components/Breadcrumb";
import Table from "../../../components/Table/Table.jsx";
import ServiceGroupModal from "./ServiceGroup-modal.jsx";

const ServiceGroups = () => {
  const {
    displayServiceGroups,
    showEditModal,
    showNewModal,
    onAddClick,
    newServiceGroup,
    handleChange,
    onSave,
    showMessage,
    setShowMessage,
    message,
    handleDeleteClick,
    handleConfirmDelete,
    showDeleteModal,
    onCloseDeleteModal,
    editServiceGroupName,
    setEditServiceGroupName,
    handleEditChangeName,
    onEdit,
    onEditClick,
    handleEditChangeOrder,
    onClosModal,
    columns,
  } = useServiceGroup();

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Service Group" child="All Groups" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}

        <Table
          columns={columns}
          data={displayServiceGroups}
          onDelete={handleDeleteClick}
          onEdit={onEditClick}
          onAddClick={onAddClick}
          title={"Service Group List"}
        />
        {showNewModal && (
          <ServiceGroupModal
            handleChangeOrder={handleChange}
            orderNumber={newServiceGroup.orderNumber}
            onCloseModalClick={onClosModal}
            showModal={showNewModal}
            serviceGroupName={newServiceGroup.name}
            handleChangeName={handleChange}
            onFormClick={() => onSave()}
            maxRo={displayServiceGroups.length}
            title={"New Service Group"}
          />
        )}
        {showEditModal && (
          <ServiceGroupModal
            handleChangeOrder={handleEditChangeOrder}
            orderNumber={editServiceGroupName.orderNumber}
            onCloseModalClick={onClosModal}
            showModal={showEditModal}
            serviceGroupName={editServiceGroupName.name}
            handleChangeName={handleEditChangeName}
            onFormClick={() => onEdit()}
            maxRo={displayServiceGroups.length}
            title={"Edit service group"}
          />
        )}
        <DeleteConfirmationModal
          show={showDeleteModal}
          onClose={() => onCloseDeleteModal()}
          onConfirm={handleConfirmDelete}
          message="Are you sure you want to delete this group?"
        />
      </div>
    </div>
  );
};

export default ServiceGroups;
